import { render, staticRenderFns } from "./WordList.vue?vue&type=template&id=fc029a24&scoped=true&"
import script from "./WordList.vue?vue&type=script&lang=js&"
export * from "./WordList.vue?vue&type=script&lang=js&"
import style0 from "./WordList.vue?vue&type=style&index=0&id=fc029a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc029a24",
  null
  
)

export default component.exports